export const backupRouteEntries = {
  backupPoliciesList: () => import('./presentation/BackupPoliciesListPage'),
} as const;